module.exports = __webpack_public_path__ + "img/BiologyLogo.57514204.svg";